import { ReadStoreGroupMember } from "@/types/storeGroupMember";
import { SuccessFetchListResponse } from "@/services/api";
import { StoreGroupService } from "@/modules/storeGroups/service";
import { UseDataTableOptions } from "@/types/dataTableSettings";
import {
  InfiniteData,
  keepPreviousData,
  QueryKey,
  useInfiniteQuery,
} from "@tanstack/react-query";

export const useFetchGroupStoresInfiniteQuery = (
  id: string | undefined,
  options: UseDataTableOptions<ReadStoreGroupMember>,
  queryKey: QueryKey,
) => {
  return useInfiniteQuery<
    SuccessFetchListResponse<ReadStoreGroupMember>,
    Error,
    InfiniteData<SuccessFetchListResponse<ReadStoreGroupMember>, string>,
    typeof queryKey,
    string
  >({
    queryKey,
    queryFn: ({ pageParam }) =>
      StoreGroupService.getList(
        {
          lastItem: pageParam,
          filters: options.filters,
          sorting: options.sorting[0],
        },
        `/${id}/stores`,
      ),
    initialPageParam: "",
    getNextPageParam: ({ last_item }) => last_item,
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
    enabled: !!id,
  });
};
